import React, { Fragment } from "react";
import Next from "../Assets/img/Home/next.png";
import Pranjal from "../Assets/img/person/pranjal.png";
import Ayushi from "../Assets/img/person/ayushi.png";
import Praharsha from "../Assets/img/person/praharsha.png";
import Manasa from "../Assets/img/person/manasa.png";
import Manasvi from "../Assets/img/person/manasvi.png";
import Anisha from "../Assets/img/person/anisha.png";
import ash from "../Assets/img/person/as.jpeg";
import av from "../Assets/img/person/Abhijeet Vichare.jpg";
import ap from "../Assets/img/person/AKASH PATIL.jpg";
import nr from "../Assets/img/person/NEHA RAMYA.jpg";
import sn from "../Assets/img/person/SAI NITISH.jpg";
import sG from "../Assets/img/person/SIDDHARTHA GHOSH.jpg";
import amazon_logo from "../Assets/img/Home/company-logo3.png";
import RectangleX from "../Assets/img/Home/Rectangle 1029@2x.png";
import amazon_logo1 from "../Assets/img/Home/company-logo15.png";
import ff from "../Assets/img/Home/ff.png";
import fk from "../Assets/img/Home/flipkart.png";
import merilytics from "../Assets/img/Home/merilytics-logo.png";
import nomuraLogo from "../Assets/img/Home/Nomura_logo.png";
import exlLogo from "../Assets/img/Home/exl-logo.png";
import cognizantLogo from "../Assets/img/Home/cognizant-logo.png";
import capLogo from "../Assets/img/Home/capgemini-logo.png";
import studentMob from "../Assets/img/Home/student-mob.png";

// import Media from "react-media";
import useMedia from "./useMedia";
import { Link } from "react-router-dom";
import styles from "../Assets/css/student.module.css";
function Student() {
	const match = useMedia("(min-width : 800px )");

	const ayushi = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={Ayushi} alt="" />
				<h2 className={styles.studentname}>Ayushi</h2>
				<img className={styles.studentcompanylogo} src={fk} alt="" />
			</div>
		</div>
	);

	const abhijeet = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={av} alt="" />
				<h2 className={styles.studentname}>Abhijeet</h2>
				<img
					className={styles.studentcompanylogo}
					style={{ height: "50px", marginTop: "10px" }}
					src={merilytics}
					alt=""
				/>
			</div>
		</div>
	);

	const neha = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={nr} alt="" />
				<h2 className={styles.studentname}>Neha</h2>
				<img
					className={styles.studentcompanylogo}
					src={amazon_logo}
					alt=""
				/>
			</div>
		</div>
	);

	const akash = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={ap} alt="" />
				<h2 className={styles.studentname}>Akash</h2>
				<img
					className={styles.studentcompanylogonl}
					style={{ height: "25px", marginTop: "10px" }}
					src={nomuraLogo}
					alt=""
				/>
			</div>
		</div>
	);

	const praharsha = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={Praharsha} alt="" />
				<h2 className={styles.studentname}>Praharsha</h2>
				<img
					className={styles.studentcompanylogoff}
					src={ff}
					style={{ height: "40px", marginTop: "10px" }}
					alt=""
				/>
			</div>
		</div>
	);

	const pranjal = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={Pranjal} alt="" />
				<h2 className={styles.studentname}>Pranjal</h2>
				<img
					className={styles.studentcompanylogo}
					style={{ height: "50px" }}
					src={exlLogo}
					alt=""
				/>
			</div>
		</div>
	);

	const manasvi = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={Manasvi} alt="" />
				<h2 className={styles.studentname}>Manasvi</h2>
				<img
					className={styles.studentcompanylogoff}
					style={{ height: "40px", marginTop: "10px" }}
					src={ff}
					alt=""
				/>
			</div>
		</div>
	);

	const sai = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={sn} alt="" />
				<h2 className={styles.studentname}>Sai</h2>
				<img
					className={styles.studentcompanylogocl}
					src={cognizantLogo}
					style={{ height: "50px" }}
					alt=""
				/>
			</div>
		</div>
	);

	const manasa = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={Manasa} alt="" />
				<h2 className={styles.studentname}>Manasa</h2>
				<img
					className={styles.studentcompanylogocg}
					style={{ height: "50px" }}
					src={capLogo}
					alt=""
				/>
			</div>
		</div>
	);

	const anisha = (
		<div className={styles.studentsWidth}>
			<div className={styles.studentbox}>
				<img className={styles.studentimage} src={Anisha} alt="" />
				<h2 className={styles.studentname}>Anisha</h2>
				<img
					className={styles.studentcompanylogo}
					src={exlLogo}
					style={{ height: "50px" }}
					alt=""
				/>
			</div>
		</div>
	);

	const styles2 = {
		"@media(max-width:650px)": {
			mobRes1: {
				display: "flex",
			},
		},
	};
	return (
		<div style={{ overflowX: "hidden" }}>
			<div className="container" style={{ marginTop: "5%" }}>
				{match ? (
					<div style={{ padding: "4%" }}>
						<div className="row">
							<Fragment>{ayushi}</Fragment>
							<Fragment>{abhijeet}</Fragment>
							<Fragment>{neha}</Fragment>
							<Fragment>{akash}</Fragment>
							<Fragment>{praharsha}</Fragment>
						</div>

						<div className="row" style={{ padding: "2%" }}>
							<Fragment>{pranjal}</Fragment>
							<Fragment>{manasvi}</Fragment>
							<Fragment>{sai}</Fragment>
							<Fragment>{manasa}</Fragment>
							<Fragment>{anisha}</Fragment>
						</div>
					</div>
				) : (
					<div className={styles2.mobRes1}>
						<img
							style={{
								margin: "auto",
								display: "block",
								height: "75vw",
								width: "76vw",
							}}
							src={studentMob}
						/>
					</div>
				)}

				{/* <div className="mob-res1">
			  <div className="col-sm-6 col-md-1-2">
				{" "}
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={ash} alt="" />
				  <h2 className={styles.studentname} >Ayushi</h2>
				  <img className={styles.studentcompanylogo} src={fk} alt="" />
				</div>{" "}
			  </div>
			  <div className="col-sm-6 col-md-1-2">
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={av} alt="" />
				  <h2 className={styles.studentname} >Abhijeet</h2>
				  <img
					className={styles.studentcompanylogo}
					style={{ height: "50px", marginTop: "10px" }}
					src={merilytics}
					alt=""
				  />
				</div>
			  </div>{" "}
			</div>
			<div className="mob-res1">
			  <div className="col-sm-6 col-md-1-2">
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={nr} alt="" />
				  <h2 className={styles.studentname} >Neha</h2>
				  <img
					className={styles.studentcompanylogo}
					src={amazon_logo}
					alt=""
				  />
				</div>{" "}
			  </div>
			  <div className="col-sm-6 col-md-1-2">
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={ap} alt="" />
				  <h2 className={styles.studentname} >Akash</h2>
				  <img
					className="studentcompanylogo-nl"
					style={{ height: "25px", marginTop: "10px" }}
					src={nomuraLogo}
					alt=""
				  />
				</div>{" "}
			  </div>
			</div>
			<div className="mob-res1">
			  <div className="col-sm-6 col-md-1-2">
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={av} alt="" />
				  <h2 className={styles.studentname} >Praharsha</h2>
				  <img
					className="studentcompanylogo-ff"
					src={ff}
					style={{ height: "40px", marginTop: "10px" }}
					alt=""
				  />
				</div>
			  </div>
			  <div className="row" style={{ padding: "4%" }}>
				<div className="col-sm-6 col-md-1-2">
				  <div className={styles.studentbox}>
					{" "}
					<img className={styles.studentimage}  src={av} alt="" />
					<h2 className={styles.studentname} >Pranjal</h2>
					<img
					  className={styles.studentcompanylogo}
					  style={{ height: "50px" }}
					  src={exlLogo}
					  alt=""
					/>
				  </div>{" "}
				</div>
			  </div>
			</div>{" "}
			<div className="mob-res1">
			  <div className="col-sm-6 col-md-1-2">
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={av} alt="" />
				  <h2 className={styles.studentname} >Manasvi</h2>
				  <img
					className="studentcompanylogo-ff"
					style={{ height: "40px", marginTop: "10px" }}
					src={ff}
					alt=""
				  />
				</div>{" "}
			  </div>
			  <div className="col-sm-6 col-md-1-2">
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={sn} alt="" />
				  <h2 className={styles.studentname} >Sai</h2>
				  <img
					className="studentcompanylogo-cl"
					src={cognizantLogo}
					style={{ height: "50px" }}
					alt=""
				  />
				</div>{" "}
			  </div>
			</div>
			<div className="mob-res1">
			  <div className="col-sm-6 col-md-1-2">
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={av} alt="" />
				  <h2 className={styles.studentname} >Manasa</h2>
				  <img
					className="studentcompanylogo-cg"
					style={{ height: "50px" }}
					src={capLogo}
					alt=""
				  />
				</div>{" "}
			  </div>
			  <div className="col-sm-6 col-md-1-2">
				<div className={styles.studentbox}>
				  {" "}
				  <img className={styles.studentimage}  src={av} alt="" />
				  <h2 className={styles.studentname} >Anish</h2>
				  <img
					className={styles.studentcompanylogo}
					src={exlLogo}
					style={{ height: "50px" }}
					alt=""
				  />
				</div>{" "}
			  </div>
			</div> */}
				{/* </div> */}
			</div>

			<div class=" container enroll p-3">
				<div class="enroll-inner" style={{ display: "inline-block" }}>
					<div>
						<h4 data-aos="fade-left" data-aos-duration="1000">
							OUR STUDENTS
						</h4>
					</div>
					<div>
						<h2 data-aos="fade-left" data-aos-duration="2000">
							WANT TO BE THE NEXT ONE
						</h2>
					</div>
					<div>
						<button
							class={styles.internbtn}
							style={{ fontFamily: "Poppins-Bold" }}
						>
							<Link to="/placementcourse">Enroll Now</Link>
						</button>
					</div>
				</div>
				{match == true ? (
					<img
						style={{ float: "right", width: "25%", height: "25%" }}
						src={RectangleX}
					/>
				) : null}
			</div>
		</div>
	);
}

export default Student;
